module.exports = __webpack_public_path__ + "img/sephotaSet3.500e485d.jpg";